/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Update cart count badges
  function updateCartCount(count) {
    const cartCountElements = document.querySelectorAll('[data-cart-count]');
    cartCountElements.forEach(el => {
      el.textContent = count;
      if (count > 0) {
        el.style.display = 'flex';
      } else {
        el.style.display = 'none';
      }
    });
  }

  // Fetch and update cart count
  function fetchCartCount() {
    if (window.theme && window.theme.routes) {
      fetch(window.theme.routes.cart_url + '.js')
        .then(response => response.json())
        .then(cart => updateCartCount(cart.item_count))
        .catch(err => console.error('Cart count update failed:', err));
    }
  }

  // Listen for cart events
  document.addEventListener('theme:cart:added', fetchCartCount);
  document.addEventListener('theme:cart:loaded', fetchCartCount);
  
  // Update on page load
  fetchCartCount();




  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
